import { Component, OnInit, OnDestroy, Input, Output, EventEmitter } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import { MaterializeAction, MaterializeDirective, toast } from 'angular2-materialize';
import { ActivatedRoute } from '@angular/router';
import { Utils } from '../../util';

import { RemissionService, ProductionOrder, Box } from '../../services/remission.service';
import { CustomerSupplierService } from '../../services/customer-supplier.service';
import { FiscalDataService } from '../../services/fiscal-data.service';
import { AddressService } from '../../services/address.service';
import { ProductionOrderService, ProductionOrderData } from '../../services/production-order.service';
import { CatalogsSettingsService, PayrollId } from '../../services/catalogs-settings.service';

import { ISubscription, Subscription } from "rxjs/Subscription";
import { AuthService } from '../../services/auth.service';
import { AutoService, FsAuto } from '../../services/auto.service';
import { EmployeeId, EmployeeService } from '../../services/employee.service';
import { Globals } from '../../globals';
import { FirestoreService } from '../../services/firestore/firestore.service';

@Component({
  selector: 'app-create-remission',
  templateUrl: './create-remission.component.html',
  styleUrls: ['./create-remission.component.css']
})
export class CreateRemissionComponent implements OnInit, OnDestroy {
  fromOdpId: string;

  customerId: string;
  customerName: string = '';

  form: FormGroup;

  fiscalDatas = {};
  selectedFiscalDataId: string;

  addresss = {};
  selectedAddressId: string = '';

  autos: {[id: string]: FsAuto} = {};
  selectedAutoId: string = '';

  employees: {[id: string]: EmployeeId} = {};
  selectedDriverEmployeeId: string = '';

  productionOrders = {};
  selectedProductionOrderId: string;
  remittedQuantity: number = 0;
  productionOrderStatus: string = '';
  productionOrder: ProductionOrder = {
    id: '',
    folio: '-',
    quantity: 0,
    prClientCode: '-',
    prClientVersion: '-',
    prClientBarCode: '-',
    customerPurchaseOrderNumber: '-'
  };

  modalActionsRead = new EventEmitter<string|MaterializeAction>();
  modalParamsRead = [{dismissible: true}];
  
  //requestedFolio: number;
  settings: PayrollId;
  pickadateParams = Utils.pickadateParams();

  subs = [];

  remInputObj = {
    distanceTraveledKm: {key: 'distanceTraveledKm', label: 'Distancia Recorrida Km', type: 'number', value: 0},
    dateArrival: {key: 'dateArrival', label: 'Fecha llegada', type: 'date', value: Utils.today},
    timeArrival: {key: 'timeArrival', label: 'Hora llegada', type: 'time', value: `01:00PM`},
    weightBoxesKg: {key: 'weightBoxesKg', label: 'Peso Cajas Kg', type: 'number', value: 0},
    license: {key: 'license', label: 'Licencia', type: 'text', value: ''},
    permitSCT: {key: 'permitSCT', label: 'Permiso SCT', type: 'text', value: ''},
  };
  get remInputs(){ return Object.values(this.remInputObj); }

  constructor(
    private service: RemissionService,
    private customerService: CustomerSupplierService,
    private fiscalDataService: FiscalDataService,
    private addressService: AddressService,
    private productionOrderService: ProductionOrderService,
    private productionOrderData: ProductionOrderData,
    private settingsService: CatalogsSettingsService,
    private activatedRoute: ActivatedRoute,
    private authService: AuthService,
    private autoService: AutoService,
    private employeeService: EmployeeService,
    private fsService: FirestoreService,
    private fb: FormBuilder
  ) {
    this.customerId = this.activatedRoute.snapshot.paramMap.get('customerId');
    this.subs.push( this.customerService.getCustomerSupplier(this.customerId).subscribe(c => { this.customerName = c.name }) );

    this.subs.push(
      this.fiscalDataService.getCustomerFiscalDatas(this.customerId).subscribe(fiscalDatas => {
        this.fiscalDatas = {};
        this.rowsRead[0] = fiscalDatas.filter(fiscalData => {
          fiscalData.name = fiscalData.businessName;
          this.fiscalDatas[fiscalData.id] = {...fiscalData};
          return fiscalData;
        });
      })
    );
    this.subs.push(
      this.addressService.getCustomerAddresses(this.customerId).subscribe(addresss => {
      this.addresss = {};
        this.rowsRead[1] = addresss.filter(address => {
          address.name = `${address.street}, #${address.externalNumber}`;
          this.addresss[address.id] = {...address};
          return address;
        });
      })
    );
    this.subs.push(
      this.productionOrderService.getProductionOrders().subscribe(productionOrders => {
        this.productionOrders = {};
        this.rowsRead[2] = productionOrders.filter(productionOrder => {
          productionOrder.statusName = productionOrder.status;
          productionOrder.status = productionOrder.statusKey;
          delete productionOrder.statusKey;
          this.productionOrders[productionOrder.id$] = {...productionOrder};
          return productionOrder.customer.id == this.customerId && ( productionOrder.status == 'key2' || productionOrder.status == 'key3' || productionOrder.status == 'key4' );
        });
        if(localStorage.odpIdToRem){
          this.currentReadIndex = 2;
          this.selectRead({row: {id: localStorage.odpIdToRem}});
          this.fromOdpId = localStorage.odpIdToRem;
          delete localStorage.odpIdToRem;
        }
      })
    );
    this.subs.push(
      this.employeeService.getEmployees().subscribe(employees => {
        this.employees = employees.reduce((acc, cur) => ({...acc, [cur.id]: {...cur}}), {});
        this.rowsRead[4] = Object.values(employees);
      })
    );
  }

  ngOnInit() {
    /* window.onbeforeunload = () => {
      this.returnRequested();
    }; */
    this.createForm();
    /* this.subs.push(
      this.settingsService.getPayrollSettings('1').subscribe(settings => {
        let requesteds = settings.folios.remissionRequesteds || [];
        let lastFolio = settings.folios.remission;
        this.settings = settings;
        if(!this.requestedFolio){
          this.requestedFolio = lastFolio + 1;
          while(requesteds.includes(this.requestedFolio)) this.requestedFolio++;
          this.form.get('folio').patchValue(this.requestedFolio);
          toast(`Se apartó el folio '${this.requestedFolio}' de configuración.`, 2000);
          console.log(`Se apartó el folio '${this.requestedFolio}' de configuración.`);
          requesteds.push(this.requestedFolio);
          settings.folios.remissionRequesteds = requesteds;
          this.settingsService.putPayrollSettings(<PayrollId>{folios: settings.folios}, '1');
        }
      })
    ); */
    this.onInit();
  }
	ngOnDestroy() {
    this.subs.map((sub, index) => {
      this.subs[index].unsubscribe();
    });
    /* this.returnRequested();
    window.onbeforeunload = null; */
  }
  async onInit(){
    let autos: FsAuto[] = await this.autoService.getAutos();
    this.autos = autos.reduce((acc, cur) => ({...acc, [cur.id]: {...cur}}), {});
    this.rowsRead[3] = Object.values(this.autos).map(auto => {
      return {name: auto.placa, ...auto};
    });
  }

  createForm(){
    this.form = this.fb.group({
      //folio: ['', Validators.required],
      date: [this.today, Validators.required],
      quantity: ['', [Validators.required, Validators.min(0)]],
      description: ['', Validators.required],
      notesEtiq: ''
    });
  }

  submittedOnce: boolean = false;
  async onSubmit({ value, valid }: { value: any, valid: any }){
    this.submittedOnce = true;
    
    let {id, fullName: name} = this.authService.currentUser;
    value.userHistory = [{id, name, date: this.today}];

    /* let settings: PayrollId = await this.fsService.docWithId(`${Globals.CATALOGS_SETTINGS}/1`) as any;
    value.folio = settings.folios.remission + 1;
    settings.folios.remission++;
    await this.settingsService.putPayrollSettings(settings, '1');
    console.log(settings); */
    //if(1) return;

    value.customerRef = this.customerId;
    value.fiscalDataRef = this.selectedFiscalDataId;
    value.addressRef = this.selectedAddressId;
    value.productionOrder = this.productionOrder;
    value.boxs = this.boxs;
    value.status = 0;

    value.autoId = this.selectedAutoId;
    value.driverEmployeeId = this.selectedDriverEmployeeId;
    for(let remInput of this.remInputs) value[remInput.key] = remInput.type == 'number' ? +remInput.value : remInput.value;

    value.folio = await this.settingsService.getNextFolioAndIncrement('remission');
    let docId = this.service.addRemission(value);
    //if(1) return alert('done');
    //this.updateSettings();
    let productionOrderUpdate = {
      remittedQuantity: value.quantity + this.remittedQuantity,
      status: (value.quantity + this.remittedQuantity) >= this.productionOrder.quantity ? 'key98' : this.productionOrderStatus,
      lastStatus: this.productionOrderStatus
    };
    this.productionOrderService.putProductionOrder(productionOrderUpdate, this.selectedProductionOrderId);
    if(!this.fromOdpId) this.service.windowReplace('view', docId);
    else this.service.windowReplace('viewOdp', this.fromOdpId);
  }
  onCancel(){
    if(!this.fromOdpId) this.service.windowReplace('read');
    else this.service.windowReplace('viewOdp', this.fromOdpId);
  }
  /* async returnRequested(){
    let requestedIndex = this.settings.folios.remissionRequesteds.indexOf(this.requestedFolio);
    if(requestedIndex > -1){
      this.settings.folios.remissionRequesteds.splice(requestedIndex, 1);
      await this.settingsService.putPayrollSettings(<PayrollId>{folios: this.settings.folios}, '1');
    }
    //this.service.windowReplace('read');
    //window.onbeforeunload = null;
  } */

  /* updateSettings(){
    let requestedIndex = this.settings.folios.remissionRequesteds.indexOf(this.requestedFolio);
    if(requestedIndex > -1){
      this.settings.folios.remissionRequesteds.splice(requestedIndex, 1);
    }
    if(this.requestedFolio > this.settings.folios.remission) this.settings.folios.remission = this.requestedFolio;
    this.settingsService.putPayrollSettings(this.settings, '1');
  } */

  get today(){
    var today = new Date();
    var dd:string = today.getDate() + '';
    var mm:string = today.getMonth()+ 1 + '';
    var yyyy = today.getFullYear();
    if(+dd<10) dd = '0'+dd;
    if(+mm<10) mm = '0'+mm;
    return yyyy + '-' + mm + '-' + dd;
  }

  //////////////////////////////////////////////////////////////////////////////////////////////BOXS
  box: Box = {} as Box;
  boxs: Box[] = [];
  modalActionsBox = new EventEmitter<string|MaterializeAction>();
  modalParamsBox = [{dismissible: true}];
  get boxIsValid(){
    const {amount, pieces} = this.box;
    //list of validators
    return !(
      !amount ||
      amount <= 0 ||
      !pieces ||
      pieces <= 0 
    )
  }
  get boxsTotal(): number {
    return this.boxs.reduce((total, {amount, pieces}) => total + amount*pieces, 0);
  }
  get boxsTotalIsValid(){
    return this.boxsTotal == this.form.get('quantity').value;
  }
  
  currentEditingIndexBox: number;
  openModalBox(index?: number) {
    this.currentEditingIndexBox = index;
    this.box = index != undefined ? {...this.boxs[this.currentEditingIndexBox]} : {} as Box;
    this.modalActionsBox.emit({ action: 'modal', params: ['open'] });
  }
  closeModalBox() {
    this.modalActionsBox.emit({ action: 'modal', params: ['close'] });
  }
  
  touchBox(){
    if(this.currentEditingIndexBox == undefined) this.boxs.push({...this.box});
    else this.boxs[this.currentEditingIndexBox] = {...this.box};
    this.closeModalBox();
  }
  removeBox(index) {
    this.boxs.splice(index,1);
  }
  //////////////////////////////////////////////////////////////////////////////////////////////BOXS

  //////////////////////////////////////////////////////////////////////////////////////////////READ MODAL DATA 
  get readValid(){ return this.selectedFiscalDataId && this.selectedAddressId && this.selectedProductionOrderId  };
  currentReadIndex: number;
  rowsRead = [[], [], [], [], []];
  columnsRead = [
    [
      { title: 'Razón Social', name: 'name', sort: 'asc' },
      { title: 'RFC', name: 'rfc' }
    ],
    [
      { title: 'Dirección', name: 'name', sort: 'asc' },
      { title: 'C.P.', name: 'zipCode' },
      { title: 'Municipio', name: 'municipality' }
    ],
    [
      { title: 'Folio', name: 'name', sort: 'desc' },
      { title: 'Compromiso de entrega', name: 'deliveryDate' },
      { title: 'Cantidad', name: 'quantity' },
      { title: 'Estatus', name: 'statusName' }
    ],
    [
      { title: 'Placa', name: 'name', sort: 'asc' },
      { title: 'Modelo', name: 'model' },
      { title: 'Año', name: 'year' },
      { title: 'Color', name: 'color' },
    ],
    [
      { title: 'Nombre', name: 'name' },
      { title: 'Appellidos', name: 'lastName', sort: 'asc' },
      { title: 'Email', name: 'email' },
      { title: 'Folio', name: 'internalKey' },
    ],
  ]

  openModalRead(index: number) {
    this.currentReadIndex = index;
    this.data = this.rowsRead[index];
    if(!this.data.length) return toast('No hay opciones para seleccionar.', 2000);
    
    this.config = this.configs[index];
  
    this.onChangeTable(this.config);
    this.modalActionsRead.emit({ action: 'modal', params: ['open'] });
  }
  closeModalRead() {
    this.modalActionsRead.emit({ action: 'modal', params: ['close'] });
  }
  selectRead({row}: {row: {id: string}}){
    if(this.currentReadIndex == 0) this.selectedFiscalDataId = row.id;
    if(this.currentReadIndex == 1) this.selectedAddressId = row.id;
    if(this.currentReadIndex == 2) {
      this.selectedProductionOrderId = row.id;
      this.remittedQuantity = this.productionOrders[row.id].remittedQuantity || 0;
      this.productionOrderStatus = this.productionOrders[row.id].status;
      let {
        id,
        name: folio,
        quantity = 0,
        prClient: { code: prClientCode = '-', version: prClientVersion = '-', barCode: prClientBarCode = '-' },
        customer: { purchaseOrderNumber: customerPurchaseOrderNumber = '-', addressId='' },
        longDescription
      } = this.productionOrders[row.id];
      this.selectedAddressId = addressId || this.selectedAddressId;
      this.productionOrder = { id, folio, quantity, prClientCode, prClientVersion, prClientBarCode, customerPurchaseOrderNumber }
      this.form.get('description').patchValue(longDescription);
    }
    if(this.currentReadIndex == 3) this.selectedAutoId = row.id;
    if(this.currentReadIndex == 4) this.selectedDriverEmployeeId = row.id;
    this.closeModalRead();
  }


  data:Array<any>;
  rows:Array<any> = [];
  page:number = 1;
  itemsPerPage:number = 5;
  maxSize:number = 5;
  numPages:number = 1;
  length:number = 0;

  config;
  configs:any = this.columnsRead.map(columns => ({
    paging: true,
    sorting: {columns: columns},
    filtering: {filterString: ''}
  }));

  /*********** Filter, sort, and pagination */

	changePage(page:any, data:Array<any> = this.data):Array<any> {
    let start = (page.page - 1) * page.itemsPerPage;
    let end = page.itemsPerPage > -1 ? (start + page.itemsPerPage) : data.length;
    return data.slice(start, end);
  }

  changeSort(data:any, config:any):any {
    if (!config.sorting) {
      return data;
    }

    let columns = this.config.sorting.columns || [];
    let columnName:string;
    let sort:string;

    for (let i = 0; i < columns.length; i++) {
      if (columns[i].sort !== undefined && columns[i].sort !== '' && columns[i].sort !== false) {
        columnName = columns[i].name;
        sort = columns[i].sort;
      }
    }

    if (!columnName) {
      return data;
    }

    // simple sorting
    return data.sort((previous:any, current:any) => {
      if (previous[columnName] > current[columnName]) {
        return sort === 'desc' ? -1 : 1;
      } else if (previous[columnName] < current[columnName]) {
        return sort === 'asc' ? -1 : 1;
      }
      return 0;
    });
  }

  changeFilter(data:any, config:any):any {
    let filteredData:Array<any> = data;
    this.columnsRead[this.currentReadIndex].forEach((column:any) => {
      if (column.filtering) {
        filteredData = filteredData.filter((item:any) => {
          return item[column.name].match(column.filtering.filterString);
        });
      }
    });

    if (!config.filtering) {
      return filteredData;
    }

    if (config.filtering.columnName) {
      return filteredData.filter((item:any) => item[config.filtering.columnName].match(this.config.filtering.filterString));
    }

    let tempArray:Array<any> = [];
    filteredData.forEach((item:any) => {
      let flag = false;
      this.columnsRead[this.currentReadIndex].forEach((column:any) => {
        if (item[column.name] && item[column.name].toString().toLowerCase().match(this.config.filtering.filterString.toLowerCase())) {
          flag = true;
        }
      });
      if (flag) {
        tempArray.push(item);
      }
    });
    filteredData = tempArray;

    return filteredData;
  }

  onChangeTable(config:any, page:any = {page: this.page, itemsPerPage: this.itemsPerPage}):any {
    if (config.filtering) {
      Object.assign(this.config.filtering, config.filtering);
    }

    if (config.sorting) {
      Object.assign(this.config.sorting, config.sorting);
    }

    let filteredData = this.changeFilter(this.data, this.config);
    let sortedData = this.changeSort(filteredData, this.config);
    this.rows = page && config.paging ? this.changePage(page, sortedData) : sortedData;
    this.length = sortedData.length;
  }

  //////////////////////////////////////////////////////////////////////////////////////////////READ MODAL DATA

}
